import { CommonModule } from '@angular/common';
import { APP_INITIALIZER } from '@angular/core';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { LOCALE_ID, importProvidersFrom, isDevMode } from '@angular/core';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import {
  RouterModule,
  provideRouter,
  withInMemoryScrolling,
  withRouterConfig,
} from '@angular/router';
import { ServiceWorkerModule } from '@angular/service-worker';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { OAuthModule } from 'angular-oauth2-oidc';

import { default as routes } from './app/app-routes';
import { AppComponent, getAppKey, getBaseUrl, getLoginUrl, getPublicBaseUrl } from './app/app.component';
import { AssistAuthService } from './app/auth/assist-auth.service';
import { AuthInterceptor } from './interceptors/auth.interceptor';

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(
      BrowserModule,
      CommonModule,
      NgbModule,
      RouterModule,
      ServiceWorkerModule.register('ngsw-worker.js', {
        enabled: !isDevMode(),
        registrationStrategy: 'registerWhenStable:30000',
      }),
      OAuthModule.forRoot({
        resourceServer: {
          allowedUrls: ['https://api.assistonline.eu'],
          sendAccessToken: true,
        },
      })
    ),
    { provide: 'LOGIN_URL', useFactory: getLoginUrl, deps: [] },
    { provide: 'BASE_URL', useFactory: getBaseUrl, deps: [] },
    { provide: 'PUBLIC_BASE_URL', useFactory: getPublicBaseUrl, deps: [] },
    { provide: 'APP_KEY', useFactory: getAppKey, deps: [] },
    { provide: LOCALE_ID, useValue: 'nl-BE' },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimations(),
    provideRouter(
      routes,
      withInMemoryScrolling({ anchorScrolling: 'enabled' }),
      withRouterConfig({ paramsInheritanceStrategy: 'always' })
    ),
    {
      // Laadt het OpenID-discovery document. De initializer rejectet nooit: faalt de auth-server
      // (bv. 500 op /.well-known/openid-configuration), dan blijft MijnAssist bruikbaar zonder
      // account en worden enkel de aanmeld-knoppen verborgen (zie AssistAuthService.initialize).
      provide: APP_INITIALIZER,
      useFactory: (authService: AssistAuthService) => () => authService.initialize(),
      deps: [AssistAuthService],
      multi: true,
    },
  ],
}).catch((err) => console.error(err));
